import { useEffect, useState } from 'react';
var usePageLoadStatus = function () {
    var _a = useState(false), isPageLoaded = _a[0], setIsPageLoaded = _a[1];
    useEffect(function () {
        var onPageLoad = function () {
            setIsPageLoaded(true);
        };
        // Check if the page has already loaded
        if (document.readyState === 'complete') {
            onPageLoad();
        }
        else {
            window.addEventListener('load', onPageLoad);
        }
        return function () { return window.removeEventListener('load', onPageLoad); };
    }, []);
    return isPageLoaded;
};
export default usePageLoadStatus;
